import UpdatePaymentInfo from './UpdatePaymentInfo';

export const MODALS = {
	UPDATE_PAYMENT_INFO: 'update_payment_info',
};

export const MODALS_BY_NAME = {
	[MODALS.UPDATE_PAYMENT_INFO]: UpdatePaymentInfo,
};
